<template>
	<footer class="footer" id="footer">
    <!-- Navigation Links Section -->
    <div class="footer-nav-section">
      <div class="wrapper">
        <nav class="footer-nav">
          <template v-if="Array.isArray($parent.textPageList) && $parent.textPageList.length > 0">
            <router-link 
              v-for="page in $parent.textPageList" 
              :key="page.id" 
              :to="{ name: 'TextPage', params: { slug: page.slug }}" 
              class="footer-nav-link">
              {{ page.title }}
            </router-link>
          </template>
          <router-link to="/contact-us" class="footer-nav-link">{{ $t('CONTACT US') }}</router-link>
        </nav>
      </div>
    </div>

    <!-- Logo Section -->
    <div class="footer-logo-section">
      <div class="wrapper">
        <div class="footer-logo">
          <span class="logo-text">{{ $t('Ruststation') }}</span>
        </div>
      </div>
    </div>

    <!-- Main Footer Content -->
    <div class="footer-content-section">
      <div class="wrapper">
        <!-- Left Side - Company Info -->
        <div class="footer-left">
          <div class="desc">
            {{ $parent.settings.copyright }}
            <br/>
            © {{ new Date().getFullYear() }}
          </div>
          <div class="desc">
            {{ $parent.settings.requisites }}
          </div>
          <div class="desc">
            {{ $t('Contact:') }} <a :href="'mailto:' + $parent.settings.support_email">{{ $parent.settings.support_email }}</a>
          </div>
        </div>

        <!-- Right Side - Social & Payment -->
        <div class="footer-right">
          <!-- Social Media Icons -->
          <div class="social-icons">
            <a 
              v-for="social in socialLinks" 
              :key="social.link" 
              :href="social.link" 
              class="social-icon"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img :src="social.image" :alt="social.link" class="social-img"/>
            </a>
          </div>

          <!-- Payment Methods -->
          <div class="payment-methods">
            <img src="../images/mc_symbol.svg" class="payment-icon" alt="Mastercard"/>
            <img src="../assets/visa.svg" class="payment-icon" alt="Visa"/>
            <img src="../images/3ds.svg" class="payment-icon" alt="3DS"/>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import Vue from 'vue'
import Clipboard from 'v-clipboard'
Vue.use(Clipboard)


export default {
	name: 'Footer',
	props: [],
	data: function() {
		return {
      copied: false,
      socialLinks: []
		}
	},
	methods: {
    clipboardSuccessHandler() {
      let self = this;
      self.copied = true;
      setTimeout(() => {
        self.copied = false;
      }, 1200);
    },
		getSocialLinks() {
      this.$http.get(process.env.VUE_APP_API + 'social-links')
      .then(({ data }) => {
        this.socialLinks = data.payload;
      })
    }
	},
	mounted() {
    this.getSocialLinks();
  }
}
</script>
